import React from 'react'

import { ReactComponent as Open } from '../../../assets/icons/eye_open.svg'
import { ReactComponent as Close } from '../../../assets/icons/eye_close.svg'

import './FilterToggleButton.scss'

export const FilterToggleButton = ({
  label,
  state,
  onClick,
}) => {
  return (
    <button
      className="filter-toggle-button"
      onClick={ onClick }
    >
      <span>
        { label }
      </span>
      {
        state
        ? <Open />
        : <Close />
      }
    </button>
  )
}